// Add to every item addition request to basket as source
export const SOURCE_BASKET = 'bd24756f4714f58adb134b5b4b6d34861c85e6ff';
export const SOURCE_BASKET_RECOMMENDED_PRODUCT = 'd9e3c2017cf4695eaf697a6d6fb737f56a6ac1c2';
